<template>
  <a-card
      class="product-details-card"
      :bordered="true"
  >
    <div class="product-details-card__body">
      <div>
        <h3>{{ product.title }}</h3>
        <p>{{ product.description }}</p>
      </div>

      <a-divider class="product-details-card__divider" />

      <div class="product-details-card__footer">
        <div>
          <div class="product-details-card__price">
            {{ getPriceLabel() }}
          </div>
          <div class="product-details-card__unit">
            {{ product.unit }}
          </div>
        </div>

        <a-button
            class="secondary-button product-details-card__button"
            @click="order"
        >
          {{ product.actionText || 'Заказать' }}
        </a-button>
      </div>
    </div>
  </a-card>
</template>

<script>
import { resolveProductPriceDisplay } from '@/utils/catalogPricing';

export default {
  name: 'ProductDetailsCard',
  emits: ['order'],
  props: {
    product: {
      type: Object,
      required: true,
    },
    quota: {
      type: [Number, String],
      required: true,
    },
  },
  setup(props, context) {
    const getPriceLabel = () => resolveProductPriceDisplay(props.product, props.quota);

    const order = () => {
      context.emit('order', props.product);
    };

    return {
      getPriceLabel,
      order,
    };
  },
};
</script>

<style scoped lang="scss">
.product-details-card {
  height: 100%;
  overflow: hidden;
  border-color: rgba(0, 0, 0, 0.08);
}

.product-details-card::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;
  background: #E9F8E6;
}

.product-details-card :deep(.ant-card-body) {
  height: 100%;
}

.product-details-card__body {
  display: flex;
  flex-direction: column;
  min-height: 144px;
  height: 100%;
}

h3 {
  margin-bottom: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
}

p {
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.45);
}

.product-details-card__footer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
}

.product-details-card :deep(.product-details-card__divider) {
  width: calc(100% + 40px);
  min-width: calc(100% + 40px);
  margin: auto -20px 14px;
}

.product-details-card__price {
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.65);
}

.product-details-card__unit {
  font-weight: 400;
  font-size: 12px;
  line-height: 110%;
  color: rgba(0, 0, 0, 0.45);
}

.product-details-card__button {
  min-width: 100px;
  color: var(--main-green);
  border-color: var(--main-green);
}
</style>
